<app-header-one></app-header-one>

<!--<div class="main-banner banner-bg1 jarallax" data-jarallax='{"speed": 0.3}'>-->
<div class="main-banner banner-bg1">

    <!--<app-home-search></app-home-search>-->

    <div class="main-banner-content2 d-flex">
        <!--<div style="justify-content: center; align-content: end;">
            <h1>{{'Nakhal_Fort' | translate }}</h1>
        </div>-->
        

        <div class="main-categories-box">
            <ul>
                <li>
                    <a href="https://car-rental.hekaya.co/pick-up-and-drop-off" target="_blank">
                        <span class="icon">
                            <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/icon2.png" alt="Car Icon- Pick&Drop">
                        </span> {{'Pick_Drop' | translate }}
                    </a>
                </li>
                <li>
                    <a href="https://car-rental.hekaya.co/self-drive" target="_blank">
                        <span class="icon">
                            <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/icon4.png" alt="Car Icon- Self Drive">
                        </span> {{'Self_Drive' | translate }}
                    </a>
                </li>
                <li>
                    <a href="https://hekaya.co/default.aspx" target="_blank">
                        <span class="icon">
                            <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/icon3.png" alt="Car Icon- Packages">
                        </span> {{'Packages' | translate }}
                    </a>
                </li>
                <li>
                    <a href="https://visa.hekaya.co/" target="_blank">
                        <span class="icon">
                            <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/icon5.png" alt="Visa Icon">
                        </span> {{'Visa' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    
</div>


<br />
<br />
<br />
<br />

<section class="w-100 mt-5">
    <div class="container">
        <div class="row" style="align-content: start;">

            <div class="col-lg-6">
                <h1 class="hekayat-titl"><span class="hekayat-color service8">{{'Hekaya.co_Visa_Web' | translate }}</span></h1>
                <!--<h1 class="hd_main">
                Welcome to <br />
                <span style="color: #a98e5f;">HEKAYA</span> Car Rental<br />
                <span class="">in <i>Oman</i></span>
            </h1>-->
                <p class="">{{'FeesTXT' | translate }}</p>
                <p class="" style="">{{'Fees2TXT' | translate }} <a class="hekayat-color" target="_blank" href="https://evisa.rop.gov.om">{{'Fees3TXT' | translate }}</a>. </p>
                <div class="justify-content-start">
                    <a routerLink="/fees" (click)="scrollToTop()" class="btn explore-button btn-md ">
                        {{'More_Details' | translate }}
                    </a>
                </div>
            </div>


            <div class="col-lg-6 d-flex align-items-start">
                <!--<img class="img-fluid" style="height: 85%; width: auto;" src="https://png.pngtree.com/png-vector/20220915/ourmid/pngtree-linear-travel-theme-man-holding-passport-and-ticket-with-trendy-style-vector-png-image_48565938.jpg" alt=" White car available for Car rentals in Oman">-->
                <div style="height: auto; width: 1000px;"><img src="assets/img/visa_oman_man.png"></div>
            </div>
        </div>

        <br />
        <br />

        <!--------------------------------------------->
        <!--------------------------------------------->
        <div class="row">
            <div class="col-lg-6 d-flex align-items-start">
                <!--<img class="img-fluid" src="https://www.pngall.com/wp-content/uploads/8/World-Travel-PNG-Image.png" alt=" White car available for Car rentals in Oman">-->
                <div style="height: auto; width: 1000px;"><img src="assets/img/visa_oman_men.png"></div>
            </div>

            <div class="col-lg-6">
                <h1 class="hekayat-titl"><span class="hekayat-color service8"> {{'Our_Service_Fees_Disclosure' | translate }}</span></h1>
                <p class="">{{'Fees4TXT' | translate }}</p>

                <p class="">{{'Fees5TXT' | translate }}</p>

                <p class="">{{'Fees6TXT' | translate }}</p>
                <div class="justify-content-start">
                    <a routerLink="/fees" (click)="scrollToTop()" class="btn explore-button btn-md ">
                        {{'More_Details' | translate }}
                    </a>
                </div>
            </div>



        </div>


        <!----------------------------------------------------->
        <!----------------------------------------------------->
        <div class="about-inner-area">
            <div>
                <div class="welcome-text">
                    <h2>{{'Want_to' | translate }} <span class="title-color">{{'Visit_Oman_and_Concern_about_your_Visa' | translate }} </span></h2>
                    <p>{{'Apply_for_Oman_Visa_with_us' | translate }} </p>
                    <br />
                </div>


                <div class="row">
                    <div class="col-lg-4 col-sm-6 col-md-4">
                        <div class="single-listing-category">
                            <a>
                                <i class='bx bx-trip'></i>
                                {{'Tourist_Visa' | translate }}
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6 col-md-4">
                        <div class="single-listing-category">
                            <a>
                                <i class='bx bx-walk'></i>
                                {{'Sponsored_Visa_Visit_Tourist_work' | translate }}
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6 col-md-4">
                        <div class="single-listing-category">
                            <a>
                                <i class='bx bxs-plane-alt'></i>
                                {{'Other_Visas' | translate }}

                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</section>



    <!--<section class="about-area">
        <div class="container">

            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="page-content text-center">
                        
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="page-content text-center">
                        <h2 class="hekayat-titl"><span class="hekayat-color service8"> {{'Our_Service_Fees_Disclosure' | translate }}</span></h2>
                        <p class="">{{'Fees4TXT' | translate }}</p>

                        <p class="">{{'Fees5TXT' | translate }}</p>

                        <p class="">{{'Fees6TXT' | translate }}</p>
                        <div class="justify-content-start">
                            <a routerLink="/fees" (click)="scrollToTop()" class="btn explore-button btn-md ">
                                {{'More_Details' | translate }}
                            </a>
                        </div>
                    </div>
                </div>



            </div>





            <div class="about-inner-area">
                <div>
                    <div class="welcome-text">
                        <h2>{{'Want_to' | translate }} <span class="title-color">{{'Visit_Oman_and_Concern_about_your_Visa' | translate }} </span></h2>
                        <p>{{'Apply_for_Oman_Visa_with_us' | translate }} </p>
                        <br />
                    </div>


                    <div class="row">
                        <div class="col-lg-4 col-sm-6 col-md-4">
                            <div class="single-listing-category">
                                <a>
                                    <i class='bx bx-trip'></i>
                                    {{'Tourist_Visa' | translate }}
                                </a>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6 col-md-4">
                            <div class="single-listing-category">
                                <a>
                                    <i class='bx bx-walk'></i>
                                    {{'Sponsored_Visa_Visit_Tourist_work' | translate }}
                                </a>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6 col-md-4">
                            <div class="single-listing-category">
                                <a>
                                    <i class='bx bxs-plane-alt'></i>
                                    {{'Other_Visas' | translate }}

                                </a>
                            </div>
                        </div>

                    </div>

                </div>
            </div>




        </div>
</section>-->

    


    <app-funfacts></app-funfacts>
    <section class="listing-area">

        <div class="container">
            <br />
            <img src="assets/img/image001.jpg" width="200">

            <iframe src='https://widgets.sociablekit.com/google-reviews/iframe/25545298' frameborder='0' width='100%' height='600'></iframe>


        </div>
        </section>
            <app-process></app-process>



            <section class="listing-area extra-pt pb-100">

                <div class="container">



                    <div class="row welcome_margin_top">
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-8 intro row_mar">
                            <h2> {{'Why_Hekaya_Visa' | translate }}</h2>

                            <!--<p class="intro-text">
                    Are you thinking about a long weekend getaway, a 2-week trip, extended travel, or something in between? Depending on where you live and the amount of time you have to travel, certain destinations will make more sense than others.
                </p>-->
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row welcome_margin_top">
                        <div class="col-lg-5" dir="rtl">
                            <div class="list_div">
                                <h4>{{'All_Online' | translate }}</h4>
                                <p>
                                    {{'You_can_apply_from_your_home' | translate }}
                                </p>
                                <br />
                                <!--<i aria-hidden="true" class="ic_float bx bxs-user ic_siz1"></i>
                    <h6 class="list_welcome">Our Customers always 100 % <br>Satisfied</h6>-->
                            </div>
                            <div class="list_div">
                                <!--<i aria-hidden="true" class="ic_float bx bxs-note ic_siz1"></i>
                    <h6 class="list_welcome">We Provide easier &amp; faster <br> Bookings </h6>-->
                                <div class="content" dir="rtl">
                                    <h4>{{'All_what_is_required' | translate }} </h4>
                                    <p>
                                        {{'All_what_is_required_TXT' | translate }}
                                    </p><br />
                                </div>
                            </div>
                            <div class="list_div">
                                <div class="content" dir="rtl">
                                    <h4>{{'Easy_to_apply' | translate }} </h4>
                                    <p>
                                        {{'Easy_to_apply_TX' | translate }}

                                    </p><br />
                                </div>
                            </div>
                            <div class="list_div">
                                <div class="content" dir="rtl">
                                    <h4>{{'Easy_to_track' | translate }} </h4>
                                    <p>
                                        {{'Easy_to_track_TXT' | translate }}

                                    </p><br />
                                </div>
                            </div>
                            <div class="list_div" dir="rtl">
                                <div class="content" dir="rtl">
                                    <h4>{{'Trust_and_Support' | translate }}  </h4>
                                    <p>
                                        {{'Trust_and_Support_TXT' | translate }}


                                    </p><br />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7"><img src="assets/img/Home_Why.jpg"></div>
                    </div>
                </div>









                <!--<div class="container">
    <div class="section-title">
        <span class="sub-title">{{'Discover' | translate }}</span>
        <h2>{{'Why_Hekaya_Visa' | translate }}</h2>
    </div>


    <div class="row">
        <div class="col-lg-2 col-sm-6 col-md-6">
            <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-tap"></i>
    </div>-->
                <!--<div class="content">
                <h3>{{'All_Online' | translate }}</h3>
                <p>
                    {{'You_can_apply_from_your_home' | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="col-lg-2 col-sm-6 col-md-6">
        <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-find"></i>
    </div>-->
                <!--<div class="content">
                <h3>{{'All_what_is_required' | translate }} </h3>
                <p>
                    {{'All_what_is_required_TXT' | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="col-lg-2 col-sm-6 col-md-6 offset-lg-0 offset-md-3 offset-sm-3">
        <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-explore"></i>
    </div>-->
                <!--<div class="content">
                <h3>{{'Easy_to_apply' | translate }} </h3>
                <p>
                    {{'Easy_to_apply_TX' | translate }}

                </p>
            </div>
        </div>
    </div>

    <div class="col-lg-2 col-sm-6 col-md-6 offset-lg-0 offset-md-3 offset-sm-3">
        <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-explore"></i>
    </div>-->
                <!--<div class="content">
                <h3>{{'Easy_to_track' | translate }} </h3>
                <p>
                    {{'Easy_to_track_TXT' | translate }}

                </p>
            </div>
        </div>
    </div>

    <div class="col-lg-2 col-sm-6 col-md-6 offset-lg-0 offset-md-3 offset-sm-3">
        <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-explore"></i>
    </div>-->
                <!--<div class="content">
                <h3>{{'Trust_and_Support' | translate }}  </h3>
                <p>
                    {{'Trust_and_Support_TXT' | translate }}


                </p>
            </div>
        </div>
    </div>
    <div class="col-lg-2 col-sm-6 col-md-6">
        <div class="single-process-box">-->
                <!--<div class="icon">
        <i class="flaticon-tap"></i>
    </div>-->
                <!--<div class="content">
                        <h3>{{'All_Online' | translate }}</h3>
                        <p>
                            {{'You_can_apply_from_your_home' | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>-->


                <button class="contact-button" [class.visible]="showScrollButton" (click)="openWhatsApp()">{{'Contact_Us' | translate }}</button>


                <button class="visa-button" [class.visible]="showScrollButton" (click)="openVisaDialog()">{{'Apply_For_Visa' | translate }}</button>

            </section>

            <div class="main-banner2 banner-bghomefooter1 jarallax" data-jarallax='{"speed": 0.3}'>

                <div class="main-banner-content2">
                    <h1>{{'Jebel_Akhdar' | translate }}</h1>


                </div>
            </div>




